export const useCompanySizeName = (sizes: any[], id: number) => {
    return sizes.find((c: any) => c.id == id)?.name ?? ''
}
